import { FC, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import ButtonBase from 'src/components/Button';
import ModalLayoutBase, { MobileModalType, ModalContent, ModalFooter as ModalFooterBase, ModalTitleContainer as ModalTitleContainerBase, ModalTitle as ModalTitleBase, ModalTitleDescription } from 'src/components/ModalLayout';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalNavButtonType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
interface STTConsentLeaveModalProps {
  onBack: () => void;
  onLeave: () => void;
}
const ModalLayout = styled(ModalLayoutBase)`
  width: 400px;
`;
const ModalTitleContainer = styled(ModalTitleContainerBase)`
  padding-bottom: 8px;
`;
const ModalTitle = styled(ModalTitleBase)`
  font-size: 18px;
  font-weight: 900;
  line-height: 23px;
`;
const Description = styled(ModalTitleDescription)`
  font-size: 14px;
  line-height: 18px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const ModalFooter = styled(ModalFooterBase)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
`;
const Button = styled(ButtonBase)`
  width: auto;

  ${({
  theme
}) => theme.screenSize.mobile} {
    width: 100%;
  }
`;

/**
 * STT 동의 모달에서 Skip 버튼을 눌렀을 때, 다시 한번 더 확인하는 넛징 모달
 */
const STTConsentLeaveModal: FC<STTConsentLeaveModalProps> = ({
  onBack,
  onLeave
}) => {
  const {
    t
  } = useTranslation();
  useEffect(() => {
    pushEvent({
      eventType: EVENT_TYPE.PROMETHEUS,
      eventName: EVENT_NAME.STT_CONSENT_POPUP__IMPRESSION_MISS_OUT_POPUP,
      eventParams: {
        action_category: 'impression',
        tab: 'anywhere',
        page: 'stt_consent_popup',
        target: 'miss_out_popup'
      }
    });
  }, []);
  const handleLeave = useCallback(async () => {
    pushEvent({
      eventType: EVENT_TYPE.PROMETHEUS,
      eventName: EVENT_NAME.STT_CONSENT_POPUP__CLICK_LEAVE_NOW,
      eventParams: {
        action_category: 'click',
        tab: 'anywhere',
        page: 'stt_consent_popup',
        target: 'leave_now'
      }
    });
    onLeave();
  }, [onLeave]);
  return <ModalLayout isDim mobileType={MobileModalType.BOTTOM_SHEET} closeWhenClickOutside={false} closeWithESC={false} navButtonType={ModalNavButtonType.NONE} mobileNavButtonType={ModalNavButtonType.NONE} data-testid='STTConsentLeaveModal' data-sentry-element="ModalLayout" data-sentry-component="STTConsentLeaveModal" data-sentry-source-file="STTConsentLeaveModal.tsx">
      <ModalTitleContainer data-sentry-element="ModalTitleContainer" data-sentry-source-file="STTConsentLeaveModal.tsx">
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="STTConsentLeaveModal.tsx">{t('azar_assistant.consent_popup_exit_title')}</ModalTitle>
      </ModalTitleContainer>
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="STTConsentLeaveModal.tsx">
        <Description dangerouslySetInnerHTML={{
        __html: t('azar_assistant.consent_popup_exit_desc')
      }} data-sentry-element="Description" data-sentry-source-file="STTConsentLeaveModal.tsx" />
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="STTConsentLeaveModal.tsx">
        <Button id='stt-consent-leave-back' color='tertiary' onClick={onBack} data-testid='STTConsentLeaveModal-button-back' data-sentry-element="Button" data-sentry-source-file="STTConsentLeaveModal.tsx">
          {t('COMMON__CANCEL')}
        </Button>
        <Button id='stt-consent-leave-now' color='secondary' onClick={handleLeave} data-testid='STTConsentLeaveModal-button-leave' data-sentry-element="Button" data-sentry-source-file="STTConsentLeaveModal.tsx">
          {t('azar_assistant.consent_popup_exit')}
        </Button>
      </ModalFooter>
    </ModalLayout>;
};
export default STTConsentLeaveModal;